import script from "./CertificateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateForm.vue?vue&type=script&setup=true&lang=js"

import "./CertificateForm.vue?vue&type=style&index=0&id=ba6c0a6a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba6c0a6a"]])

export default __exports__